import { COU_httpGet, COU_httpPost } from "@/utils/http";
import { UploadImage3 } from "@/views/moving_function/views/shipping_preview_list/bos_config";
import store from "@/store";
// 获取商品模板列表
async function GetGoodsTemplateList({ page, size, name, getDefaultTemplate }) {
  const checkMall = store.state["mall_group"].checkMall;
  const url = `/template/list?page=${page}&size=${size}&name=${name}&getDefaultTemplate=${getDefaultTemplate}&branchGroupRelId=${checkMall?.Id}`;
  const r = await COU_httpGet({ url });
  let list = [],
    total = 0,
    msg = "",
    success = false;
  try {
    msg = r.msg;
    success = r.success;
    list = r.result.Datas;
    total = r.result.TotalNum;
  } catch (error) {
    console.log(error);
  }
  if (!list) list = [];
  return { list, total, msg, success };
}
// 图片上传 (前端自己通过百度云sdk传到百度云上)
async function UploadImage2(file) {
  const result = await UploadImage3(file);
  return result?.imageUrl;
}
// 获取商品分类里的品牌
async function GetGoodsBrandList(cid) {
  const url = `/template/brandList?cid=${cid}`;
  const r = await COU_httpGet({ url });
  let list = [],
    msg = "",
    success = false;
  try {
    list = r.result.auth_brand_list;
    msg = r.msg;
    success = r.success;
  } catch (error) {
    console.log(error);
  }
  if (!list) list = [];
  return { list, success, msg };
}

// 编辑商品模板
async function EditGoodsTemplate(data) {
  const url = "/template/update";
  const r = await COU_httpPost({ url, data });
  let msg = "",
    success = false,
    result;
  try {
    msg = r.msg;
    (success = r.success), (result = r.result);
  } catch (error) {
    console.log(error);
  }
  return { success, msg, result };
}

async function AddGoodsTemplate(data) {
  const url = `/template/add`;
  const r = await COU_httpPost({ url, data });
  let msg = ``,
    success = false,
    result = {};
  try {
    msg = r.msg;
    (success = r.success), (result = r.result);
  } catch (error) {
    console.log(error);
  }
  return { success, msg, result };
}

// 获取店铺里的运费模板列表
async function GetFreightTemplateList() {
  const url = "/util/expressTemplateList";
  const r = await COU_httpGet({ url });

  let list = [],
    success = false,
    msg = "";
  try {
    msg = r.msg;
    success = r.success;
    list = r.result?.Datas || [];
  } catch (error) {
    console.log(error);
  }
  const newList = [];
  if (list?.length) {
    list.map((item) => {
      newList.push({
        id: item.TemplateId,
        name: item.TemplateName,
      });
    });
  }
  return { list: newList, msg, success };
}

// 设置为默认商品模板
async function SetDefaultTemplate(templateId) {
  const url = `/template/setDefault`;
  const r = await COU_httpPost({ url, data: { templateId } });
  let msg = "",
    success = false;
  try {
    msg = r.msg;
    success = r.success;
  } catch (error) {
    console.log(error);
  }
  return { success, msg };
}

// 删除商品模板
async function DeleteGoodsTemplate(templateId) {
  const url = `/template/delete`;
  const r = await COU_httpPost({ url, data: { templateId } });
  let msg = "",
    success = false;
  try {
    msg = r.msg;
    success = r.success;
  } catch (error) {
    console.log(error);
  }
  return { success, msg };
}

// 获取单个铺货模板详情
async function GetGoodsTemplateDetail(id) {
  const checkMall = store.state["mall_group"].checkMall;
  let url;
  if (checkMall && checkMall.Id) {
    url = `/template/info?templateId=${id}&branchGroupRelId=${checkMall?.Id}`;
  } else {
    url = `/template/info?templateId=${id}`;
  }

  // var url = `/template/info?templateId=${id}`;
  var r = await COU_httpGet({ url });
  let msg = ``,
    templateInfo = {},
    success = false;
  try {
    msg = r.msg;
    success = r.success;
    templateInfo = r.result;
  } catch (error) {
    console.log(error);
  }

  if (!templateInfo) templateInfo = {};
  return { msg, templateInfo, success };
}

export default {
  GetGoodsTemplateList,
  GetGoodsBrandList,
  EditGoodsTemplate,
  GetFreightTemplateList,
  SetDefaultTemplate,
  DeleteGoodsTemplate,
  GetGoodsTemplateDetail,
  UploadImage2,
  AddGoodsTemplate,
};
